import { render } from "./BranchTerminalCreateUpdateModel.vue?vue&type=template&id=9f7d2f18"
import script from "./BranchTerminalCreateUpdateModel.vue?vue&type=script&lang=js"
export * from "./BranchTerminalCreateUpdateModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__